import { useEffect, useContext } from 'react';
import { FLEET_TAB } from 'modules/fleet/events';
import JobReviewFiltersContext from 'modules/job-review/filters/context';
import { useSelector } from 'react-redux';
import { constants, getClientConfig } from 'redux/modules/client-config/selectors';

const JobReviewFilters = () => {
  const { filters } = useContext(JobReviewFiltersContext);
  const FILTERS = useSelector((state) => getClientConfig(state, constants.FILTERS));

  useEffect(() => {
    if (FILTERS[constants.FLEET_JOB_REVIEW]) FLEET_TAB.APPLY_FILTER(filters);
  }, [filters, FILTERS]);

  return null;
};

export default JobReviewFilters;
